import { AlertTriangle } from 'lucide-react';

export const LEGAL_NOTICE_TITLE = 'INVESTMENT RISK DISCLAIMER';
export const LEGAL_NOTICE_TEXT = 'All investments involve risk, including the possible loss of some or all of the capital invested. Cryptocurrency and financial markets are highly volatile, and past performance does not guarantee future results. Investors should carefully evaluate their financial situation, investment objectives, and risk tolerance before making any investment decision. Lions Advisory Group does not guarantee profits or returns on investments.';
export const LEGAL_NOTICE_PARAGRAPHS = [LEGAL_NOTICE_TEXT];

export const LegalNotice = ({ compact = false, className = '' }) => (
    <div className={`p-4 rounded-lg bg-amber-500/10 border border-amber-500/30 ${className}`} data-testid="legal-notice">
        <p className={`text-amber-400 font-bold flex items-center gap-1.5 mb-2 ${compact ? 'text-xs justify-center' : 'text-sm'}`}>
            <AlertTriangle className="w-3.5 h-3.5" /> {LEGAL_NOTICE_TITLE}
        </p>
        <p className={`text-amber-400/90 leading-relaxed ${compact ? 'text-[11px] text-center' : 'text-sm'}`}>{LEGAL_NOTICE_TEXT}</p>
    </div>
);
